import { indexItems } from '@/mocks/homeData';

function getColorClass(color: string) {
  if (color === 'accent') return 'bg-accent-500';
  return 'bg-primary-500';
}

function getBgClass(color: string) {
  if (color === 'accent') return 'bg-accent-100 text-accent-600';
  return 'bg-primary-100 text-primary-600';
}

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 mb-4">
            <i className="ri-stack-line text-accent-600 text-sm"></i>
            <span className="text-accent-700 text-xs font-medium">热门专题合集</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            吃瓜专题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            七大热门吃瓜专题，覆盖娱乐圈、科技圈、商界等多领域深度爆料合集
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {indexItems.map((item) => (
            <div
              key={item.id}
              className="group relative bg-background-50 border border-background-200/70 rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 via-background-950/10 to-transparent" />
                <div className={`absolute top-3 left-3 w-9 h-9 rounded-lg flex items-center justify-center ${getColorClass(item.color)}`}>
                  <i className={`${item.icon} text-background-50 text-base`}></i>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${getBgClass(item.color)}`}>
                    {item.count}条爆料
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}